<template>
  <Page
    :title="isNew ? 'neue Rechnung' : 'Rechnung ' + item.number"
    color="info"
  >
    <template slot="help"> </template>
    <template slot="extension">
      <v-tabs background-color="info darken-1" hide-slider>
        <v-toolbar color="info darken-1" dense>
          <v-btn text exact :to="abortTarget"
            ><v-icon left>mdi-arrow-left</v-icon>Abbrechen</v-btn
          >
        </v-toolbar>
      </v-tabs>
    </template>

    <v-row v-if="item">
      <v-col cols="12" md="6" lg="5" xl="5">
        <v-card class="mb-4">
          <v-system-bar>Rechnung</v-system-bar>
          <FinanceInvoice :item="item" />
        </v-card>
        <v-card>
          <v-system-bar>Betrag verteilen</v-system-bar>
          <InvoiceAmount
            :value="item"
            @updateTolerance="updateTolerance"
            readonly
          />
          <v-divider />
          <v-card-actions>
            <v-btn
              text
              @click="distribute"
              :disabled="
                !item ||
                (!item.amount && !item.amountForeign) ||
                !item.details.length
              "
              >gleichmässig verteilen</v-btn
            >
            <v-spacer />
            <FinanceInvoiceSave
              :item="item"
              @saved="
                (id) =>
                  $router.push({
                    name: 'InvoiceDetails',
                    params: {
                      id: id,
                      page: 'InvoiceNoDetails',
                    },
                  })
              "
              :tolerance="tolerance"
              :valid="true"
              distribute
            />
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="7" xl="7">
        <FinanceInvoiceDetailForm v-model="item" distribute />
      </v-col>
    </v-row>
  </Page>
</template>

<script>
import { defineComponent } from "vue";
import FinanceInvoice from "common/components/Finance/FinanceInvoice.vue";
import InvoiceAmount from "common/components/Finance/InvoiceAmount.vue";
import FinanceInvoiceDetailForm from "common/components/Finance/FinanceInvoiceDetailForm.vue";
import FinanceInvoiceSave from "common/components/Finance/FinanceInvoiceSave.vue";
import { createInvoice } from "common/utils/finance.js";

export default defineComponent({
  components: {
    FinanceInvoice,
    FinanceInvoiceDetailForm,
    FinanceInvoiceSave,
    InvoiceAmount,
  },
  props: { id: {}, page: { type: String, default: "InvoiceDetails" } },
  data() {
    return {
      loading: false,
      item: createInvoice(),
      tolerance: true,
    };
  },
  computed: {
    abortTarget() {
      return { name: "InvoiceDetails", params: { id: this.item.id } };
    },
    isNew() {
      return !this.id;
    },
  },
  watch: {},
  methods: {
    distribute() {
      const details = this.item.details;
      if (this.foreign) {
        const amountForeign =
          Math.floor((100 * this.item.amountForeign) / details.length) / 100;
        details.forEach((detail) => (detail.amountForeign = amountForeign));
      } else {
        const amount =
          Math.floor((100 * this.item.amount) / details.length) / 100;
        details.forEach((detail) => (detail.amount = amount));
      }
    },
    async saved(newId) {
      this.$router.push({
        name: "InvoiceDetails",
        params: { id: newId },
      });
    },
    updateTolerance(tolerance) {
      this.tolerance = tolerance;
    },
  },
  async created() {
    this.loading = true;
    this.item = await this.apiGet({
      resource: "finance/invoice",
      id: this.id,
    });

    this.loading = false;
  },
});
</script>
